export const getParsedValue = <T>(value: string): T | null => {
  try {
    return JSON.parse(value);
  } catch {
    return value as unknown as T;
  }
};

export const boolifyPromise = <T>(promise: Promise<T>): Promise<boolean> => {
  return promise.then(() => true).catch(() => false);
};
